import React, { useEffect, useState } from 'react'
import List from '../../../components/SiteManagement/Submitted/NewBuildingSiteQueryReportIndex/list'
import SearchFilter from '../../../components/SiteManagement/Submitted/NewBuildingSiteQueryReportIndex/searchFilter'
import Layout from '../../../components/common/pageLayout'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { v3_NewBuildingSiteQueryReportIndexForm } from '../../../actions/v3/siteManagement'
import { replacePageState } from '../../../utils';

const NewBuildingBlockInspectionStatus = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(page || 1);
    const [limit, setLimit] = useState(10);
    const [payload, setPayload] = useState('');
    // Bumped after a delete so the effect below refetches the page.
    const [refreshToken, setRefreshToken] = useState(0);
    useEffect(() => {
        v3_NewBuildingSiteQueryReportIndexForm(currentPage, limit, payload).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.submittedNewBuildingSiteQueryReportIndex.url, {
                    page: currentPage
                });
            } else {
                toast.error(res.error || "Failed to fetch list");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Something went wrong");
        });
    }, [page, limit, payload, refreshToken])
    return (
        <Layout
            title='Site Query Report Index'
        >
            <SearchFilter
                onSearch={(encryptedPayload) => { setPayload(encryptedPayload) }}
            />
            <List
                setPage={setCurrentPage}
                data={data}
                filterPayload={payload}
            onDeleted={() => setRefreshToken((t) => t + 1)}
            />
        </Layout>
    )
}

export default NewBuildingBlockInspectionStatus